module.exports = __webpack_public_path__ + "static/media/6.ad8f3d2b.png";